import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AgricolaDeclaratoriaConfirmDialogComponent } from '../agricola-declaratoria-confirm-dialog/agricola-declaratoria-confirm-dialog.component';
import { AgricolaToastType } from '../../../../../interfaces/agricola.interface';
import { SisRadioOption } from '../../../../sis/sis-radio-group/sis-radio-group.component';

interface DeclaratoriaQuestion {
  label: string;
  controlName: string;
}

@Component({
  selector: 'app-agricola-declaratoria-step',
  templateUrl: './agricola-declaratoria-step.component.html',
  styleUrls: ['./agricola-declaratoria-step.component.css'],
  standalone: false
})
export class AgricolaDeclaratoriaStepComponent implements OnInit {

  @Input() group!: FormGroup;
  @Input() selectedIndex: number = 0;
  @Input() steps: string[] = [];
  @Output() nextStep = new EventEmitter<number>();
  @Output() previousStep = new EventEmitter<void>();

  @ViewChild('stepper') stepper!: any;

  hasRiskCondition = false;
  toastMessage: string = '';
  toastType: AgricolaToastType = 'error';
  showToast: boolean = false;

  readonly yesNoOptions: SisRadioOption[] = [
    { label: 'Si', value: 'si' },
    { label: 'No', value: 'no' }
  ];

  readonly questionList: DeclaratoriaQuestion[] = [
    { label: 'Tuberculosis', controlName: 'tuberculosis' },
    { label: 'Hipertensión arterial', controlName: 'hipertension' },
    { label: 'Enfermedades mentales', controlName: 'mentales' },
    { label: 'Enfermedades cardiovasculares', controlName: 'cardiovasculares' },
    { label: 'Enfermedades cerebrovasculares: Derrame (Isquemia, trombosis, hemorragía)', controlName: 'cerebro' },
    { label: 'Enfermedades renales crónicas', controlName: 'renales' },
    { label: 'Enfermedades pulmonares crónicas', controlName: 'pulmonares' },
    { label: 'Diabetes', controlName: 'diabetes' },
    { label: 'Ataque de delirium tremens', controlName: 'delirium' },
    { label: 'Epilepsia', controlName: 'epilepsia' },
    { label: 'Cáncer-Linfoma- Tumores malignos Metástasis', controlName: 'cancer' },
    { label: 'Leucemias', controlName: 'leucemias' },
    { label: 'Cirrosis hepática', controlName: 'cirrosis' },
    { label: 'Alcoholismo crónico', controlName: 'alcoholismo' },
    { label: 'Hepatitis B y C', controlName: 'hepatitis' },
    { label: 'Úlcera de estómago o duodeno', controlName: 'ulcera' },
    { label: 'VIH o Sida', controlName: 'vih' },
    { label: '¿Padece o ha padecido de alguna discapacidad o defecto físico como sordera, ceguera, paraplejía, cuadriplejía, apoplejía?', controlName: 'discapacidad' },
    { label: '¿Tienes hospitalizaciones o cirugías programadas?', controlName: 'hospitalizaciones' }
  ];

  constructor(private dialog: MatDialog) {}

  get questions(): FormGroup {
    return this.group.get('questions') as FormGroup;
  }

  get confirmation(): FormGroup {
    return this.group.get('confirmation') as FormGroup;
  }

  ngOnInit(): void {
    this.updateRiskFlag();
    this.questions.valueChanges.subscribe(() => this.updateRiskFlag());
  }

  private updateRiskFlag(): void {
    const q = this.questions.value;
    const keys = Object.keys(q).filter(k => k !== 'otrasEnfermedades');
    this.hasRiskCondition = keys.some(key => q[key] === 'si');
    
    // Mostrar toast si hay condición de riesgo
    if (this.hasRiskCondition) {
      this.showToastMessage(
        'La póliza NO puede ser emitida. Si procedes con la emisión, el asegurado no tendrá derecho a ningún beneficio descrito en la póliza.',
        'error'
      );
    } else {
      this.hideToast();
    }
  }

  showToastMessage(message: string, type: AgricolaToastType = 'error'): void {
    this.toastMessage = message;
    this.toastType = type;
    this.showToast = true;
  }

  hideToast(): void {
    this.showToast = false;
  }

  goBack(): void {
    // Emitir evento para que el componente padre maneje la navegación hacia atrás
    this.previousStep.emit();
  }

  goToStep(index: number): void {
    console.log('goToStep', index);
    if (index <= this.selectedIndex && this.stepper) {
      this.selectedIndex = index;
      this.stepper.selectedIndex = this.selectedIndex;
    }
  }

  cancel() {
    console.log('Cancelar wizard');
  }

  goToNextStep(event: any) {
    // Abrir el modal de confirmación
    this.openDeclaratoriaConfirm();
  }

  openDeclaratoriaConfirm() {
    const dialogRef = this.dialog.open(AgricolaDeclaratoriaConfirmDialogComponent, {
      width: '520px',
      disableClose: true,
      data: this.confirmation?.value
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // Actualizar el valor de confirmación en el formulario
        this.confirmation?.get('accepted')?.setValue(true);
        // Emitir el índice del siguiente step para avanzar
    const nextIndex = this.selectedIndex + 1;
    this.nextStep.emit(nextIndex);
      }
    });
  }
}
